import React from 'react';
import styled from '../../components/styled';
import { useDispatch } from 'react-redux';

import { Asset, AssetDictionary, AssetType, Site } from '../../services/dataModels';
import { CustomModal, SelectableRow } from '../../components';
import {
  preferenceActions,
  selectPreferenceModal,
  selectPreferences,
  selectAllBusinessTeams,
  selectAllConsoles,
  selectAllPosts,
  selectAllSites,
} from '../../store/';
import { AppDispatch } from '../../store/store';

const AssetsModal = () => {
  const dispatch = useDispatch<AppDispatch>();

  const modalAssetType = selectPreferenceModal.useHook();
  const preferences = selectPreferences.useHook();
  const businessTeams = selectAllBusinessTeams.useHook();
  const consoles = selectAllConsoles.useHook();
  const posts = selectAllPosts.useHook();
  const sites = selectAllSites.useHook();

  const settings: Record<
    AssetType,
    {
      action: (param: any) => void;
      assets: AssetDictionary;
      preference?: Asset;
    }
  > = {
    'Business Team': {
      action: preferenceActions.setPreferredBusinessTeam,
      assets: businessTeams,
      preference: preferences.businessTeam,
    },
    Console: {
      action: preferenceActions.setPreferredConsole,
      assets: consoles,
      preference: preferences.console,
    },
    Post: {
      action: preferenceActions.setPreferredPost,
      assets: posts,
      preference: preferences.post,
    },
    Site: {
      action: preferenceActions.setPreferredSite,
      assets: sites,
      preference: preferences.site,
    },
  };

  const handleAssetModelDismissed = () => {
    dispatch(preferenceActions.assetTypeSelected(undefined));
  };

  const handleAssetSelected = (asset: any) => {
    if (settings[modalAssetType].preference?.assetName === asset.assetName) {
      dispatch(settings[modalAssetType].action(undefined) as any);
    } else {
      dispatch(settings[modalAssetType].action(asset) as any);
    }

    handleAssetModelDismissed();
  };

  return (
    <CustomModal
      title={modalAssetType}
      isVisible={typeof modalAssetType !== 'undefined'}
      dismissModal={handleAssetModelDismissed}>        
      {Object.values(settings[modalAssetType]?.assets ?? []).map((asset) => (
        <AssetOption key={asset.assetName}>                  
          <SelectableRow
            title={asset.displayName}
            subtitle={(asset as Site)?.siteCode}
            isSelected={settings[modalAssetType].preference?.assetName === asset.assetName}
            onSelection={() => handleAssetSelected(asset)}
          />
        </AssetOption>
      ))}
    </CustomModal>
  );
};

export default AssetsModal;

const AssetOption = styled.View``;
